export default __webpack_public_path__ + "static/media/UpperGI_tilt_set_up_Female_.b0b3bd7a.png";